"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "valdisotto": {
    "e8e80625": [{
      "hkey": "426069c8",
      "slug": "cepina-piazza",
      "name": "Cepina-Piazza",
      "primary": true,
      "skipSearch": false
    }],
    "cepina": [{
      "hkey": "426069c8",
      "slug": "cepina-piazza",
      "name": "Cepina-Piazza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ca03ee67": [{
      "hkey": "426069c8",
      "slug": "cepina-piazza",
      "name": "Cepina-Piazza",
      "primary": true,
      "skipSearch": false
    }],
    "piazza": [{
      "hkey": "426069c8",
      "slug": "cepina-piazza",
      "name": "Cepina-Piazza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "valdisotto"
    }],
    "d0450549": [{
      "hkey": "edc45032",
      "slug": "valdisotto",
      "name": "Valdisotto",
      "primary": true,
      "skipSearch": false
    }],
    "san-bartolomeo": [{
      "hkey": "edc45032",
      "slug": "valdisotto",
      "name": "Valdisotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4ba9fc4f": [{
      "hkey": "cb078498",
      "slug": "aquilone",
      "name": "Aquilone",
      "primary": true,
      "skipSearch": false
    }],
    "sant-antonio-aquilone": [{
      "hkey": "cb078498",
      "slug": "aquilone",
      "name": "Aquilone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;